import { apiSlice } from "./apiSlice";

export const DarkModeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateDarkMode: builder.mutation({
      query: ({ modeValue }: { modeValue: any }) => ({
        url: `/utility/profile/uim/update/darkMode?mode=${modeValue}`,
        method: "POST"
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useUpdateDarkModeMutation } = DarkModeApiSlice;
